var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.selectModel(this.modelValue, this.dataSelectorKey) || 0)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }